var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page"},[_c('header-prismic'),_c('div',{staticClass:"container"},[_c('prismic-edit-button',{attrs:{"documentId":_vm.documentId}}),_c('slices-block',{attrs:{"slices":_vm.slices}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }